(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
if (!customElements.get('vulgr-shipping-motion')) {
  customElements.define('vulgr-shipping-motion', class extends HTMLElement {
    static hasPlayed = false;

    connectedCallback() {
      this.bar = this.closest('.vulgr-shipping');
      this.drawer = this.closest('cart-drawer');
      if (!this.bar || !this.drawer) return;
      this.animations = [];
      this.particles = [];
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onOpen = (event) => {
        if (event.target === this.drawer) this.play();
      };
      this.onClose = (event) => {
        if (event.target === this.drawer) this.stop();
      };
      this.onPreferenceChange = () => {
        if (this.motionPreference.matches) this.stop();
      };
      this.drawer.addEventListener('openable-element:open', this.onOpen);
      this.drawer.addEventListener('openable-element:close', this.onClose);
      this.motionPreference.addEventListener('change', this.onPreferenceChange);
      if (this.drawer.hasAttribute('open')) this.play();
    }

    disconnectedCallback() {
      this.stop();
      this.drawer?.removeEventListener('openable-element:open', this.onOpen);
      this.drawer?.removeEventListener('openable-element:close', this.onClose);
      this.motionPreference?.removeEventListener('change', this.onPreferenceChange);
    }

    stop() {
      (this.animations || []).forEach((animation) => {
        animation.onfinish = null;
        animation.cancel();
      });
      (this.particles || []).forEach((particle) => particle.remove());
      this.animations = [];
      this.particles = [];
      this.bar?.classList.remove('is-shipping-travelling');
    }

    animatePart(element, frames, timing) {
      const animation = element.animate(frames, timing);
      this.animations.push(animation);
      return animation;
    }

    play() {
      if (this.constructor.hasPlayed) return;
      try {
        if (window.sessionStorage.getItem('vulgrco:shipping-motion:played') === '1') {
          this.constructor.hasPlayed = true;
          return;
        }
      } catch {}
      this.stop();
      if (!this.isConnected || !this.drawer.hasAttribute('open') || this.motionPreference.matches || !this.animate) return;
      const progress = Math.min(1, Math.max(0, Number(this.dataset.progress) || 0));
      const rail = this.querySelector('.vulgr-shipping__rail');
      const truck = this.querySelector('.vulgr-shipping__truck');
      const fill = this.querySelector('.vulgr-shipping__fill');
      if (!rail || !truck || !fill || progress === 0) return;
      const complete = this.bar.classList.contains('vulgr-shipping--complete');
      const width = rail.getBoundingClientRect().width;
      if (width <= 0) return;
      this.constructor.hasPlayed = true;
      try {
        window.sessionStorage.setItem('vulgrco:shipping-motion:played', '1');
      } catch {}
      const distance = complete ? width : Math.min(width * progress, Math.max(0, width - 48));
      const timing = { duration: complete ? 1100 : 850, delay: 220, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)', fill: 'both' };
      this.bar.classList.add('is-shipping-travelling');
      this.animatePart(fill, [{ transform: 'scaleX(0)' }, { transform: `scaleX(${progress})` }], timing);
      const travel = this.animatePart(truck, [
        { transform: 'translateX(-50%)' },
        { transform: `translateX(calc(-50% + ${distance}px))` }
      ], timing);
      travel.onfinish = () => {
        this.stop();
        if (complete && this.isConnected && this.drawer.hasAttribute('open') && !this.motionPreference.matches) this.celebrate(rail);
      };
    }

    celebrate(rail) {
      const goal = this.querySelector('.vulgr-shipping__goal');
      const check = this.querySelector('.vulgr-shipping__check');
      if (!goal || !check) return;
      this.animatePart(goal, [
        { transform: 'translateX(-50%) scale(0.88)', backgroundColor: '#111111' },
        { transform: 'translateX(-50%) scale(1.12)', offset: 0.55 },
        { transform: 'translateX(-50%) scale(1)' }
      ], { duration: 320, easing: 'ease-out' });
      this.animatePart(check, [
        { opacity: 0, transform: 'scale(0.35) rotate(-20deg)' },
        { opacity: 1, transform: 'scale(1) rotate(0deg)' }
      ], { duration: 260, easing: 'ease-out' });
      for (let index = 0; index < 12; index += 1) {
        const particle = document.createElement('span');
        particle.className = 'vulgr-shipping__confetti';
        particle.style.backgroundColor = index % 3 === 0 ? 'var(--vulgr-shipping-ink)' : 'var(--vulgr-shipping-accent)';
        const angle = (-165 + index * 13.6) * Math.PI / 180;
        const radius = 28 + (index % 4) * 6;
        const x = Math.cos(angle) * radius;
        const y = Math.sin(angle) * radius;
        const spin = (index % 2 === 0 ? 1 : -1) * (140 + index * 25);
        rail.appendChild(particle);
        this.particles.push(particle);
        const burst = this.animatePart(particle, [
          { opacity: 0, transform: 'translate(-50%, -50%) scale(0.3) rotate(0deg)', offset: 0 },
          { opacity: 1, offset: 0.12 },
          { opacity: 1, transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(1) rotate(${spin}deg)`, offset: 0.6 },
          { opacity: 0, transform: `translate(calc(-50% + ${x * 1.12}px), calc(-50% + ${y + 22}px)) scale(0.5) rotate(${spin + 70}deg)`, offset: 1 }
        ], { duration: 650, delay: 35 + index % 3 * 20, easing: 'ease-out', fill: 'both' });
        burst.onfinish = () => particle.remove();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
